import * as React from 'react';
import { Box, Button, Checkbox, Grid, IconButton, InputAdornment, Stack, Tooltip, Typography } from '@mui/material';
import constants from '../../../config/constants';
import { pwdValidation } from '../../../utils/commonUtilities';
import PasswordStrength from '../PasswordStrength';
import { loginSignup_asyncActions } from '../../../asyncActions/loginSignup_asynActions';
import { useDispatch, useSelector } from 'react-redux';
import messages from '../../../utils/messages.json';
import { InfoIcon } from '../../../components/icons';
import TextField from '../../../components/FormComponents/TextField';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
export const initial_basicInfo = { email: '', first_name: '', last_name: '', phone_number: '', password: '', confirm_password: '', dealership_code: '', isCellPhoneChecked: '' };
const initial_pwdErrors = { isValidLength: false, doesHvUCase: false, doesHvLCase: false, doesHvNum: false, doesHvSplChar: false };
const BasicInformation = (props) => {
    const { handleNext, prevProps } = props;
    const dispatch = useDispatch();
    const vendorConfig = useSelector((state) => state.vendor.vendorDetails);
    const [basicInfo, setBasicInfo] = React.useState(Object.assign({}, initial_basicInfo));
    const [basicInfoErrors, setBasicInfoErrors] = React.useState(Object.assign({}, initial_basicInfo));
    const [enableNextButton, setEnableNextButton] = React.useState(false);
    const [apiError, setApiError] = React.useState('');
    const inputRef = React.useRef(null);
    const [isCellPhoneChecked, setIsCellPhoneChecked] = React.useState(false);
    React.useEffect(() => {
        if (prevProps && Object.values(prevProps).length > 0) {
            if (prevProps.isCellPhoneChecked === true) {
                setIsCellPhoneChecked(prevProps.isCellPhoneChecked);
            }
            setBasicInfo(prevProps);
        }
    }, [prevProps]);
    React.useEffect(() => {
        const value = constants.regex.dealerCode.test(basicInfo.dealership_code);
        setEnableNextButton(isCustomerTypePortal() ? true : value);
    }, [vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.DealerName, basicInfo.dealership_code]);
    const handleOnValChange = (e) => {
        let { name, value } = e.target;
        if (name === 'phone_number') {
            value = value === null || value === void 0 ? void 0 : value.replace(constants.regex.PhoneNumber, '');
        }
        setBasicInfoErrors((prevState) => (Object.assign(Object.assign({}, prevState), { [name]: '' })));
        setBasicInfo((prevState) => (Object.assign(Object.assign({}, prevState), { [name]: value })));
    };
    const handleCheckboxChange = (e) => {
        setIsCellPhoneChecked(e.target.checked);
        setBasicInfo((prevState) => (Object.assign(Object.assign({}, prevState), { [e.target.name]: e.target.checked })));
    };
    const trimAndValidate = (value, regex, errorMessage) => {
        const trimmedValue = value.trim();
        if (trimmedValue === '') {
            return 'This field is required';
        }
        else if (regex && errorMessage && !regex.test(trimmedValue)) {
            return errorMessage;
        }
        else {
            return '';
        }
    };
    const handleOnPasswordPaste = (event) => {
        event.preventDefault();
    };
    const handleOnNextClick = () => {
        if (isValidFormData()) {
            if (isCustomerTypePortal()) {
                const payload = {
                    'Email': basicInfo.email,
                };
                if (vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.IsActivationCodeEnabled) {
                    payload.ActivationCode = basicInfo.dealership_code;
                }
                dispatch(loginSignup_asyncActions.verifyEmail(payload))
                    .then((response) => {
                    var _a, _b, _c, _d, _e;
                    if (response.data && response.data.statusCode === 200) {
                        basicInfo.isCellPhoneChecked = isCellPhoneChecked;
                        handleNext(1, basicInfo, []);
                    }
                    else {
                        if ((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.Email) {
                            setBasicInfoErrors((prevState) => { var _a, _b; return (Object.assign(Object.assign({}, prevState), { email: (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.Email })); });
                            (_c = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _c === void 0 ? void 0 : _c.focus();
                        }
                        else if ((_e = (_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.ActivationCode) {
                            setBasicInfoErrors((prevState) => { var _a, _b; return (Object.assign(Object.assign({}, prevState), { dealership_code: (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.ActivationCode })); });
                        }
                        else {
                            setApiError(() => { var _a; return ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message); });
                        }
                    }
                }).catch((error) => {
                    setApiError(() => (error.message));
                });
            }
            else {
                const payload = {
                    'Email': basicInfo.email,
                    'ActivationCode': basicInfo.dealership_code
                };
                dispatch(loginSignup_asyncActions.verifyDealerCode(payload))
                    .then((response) => {
                    var _a, _b, _c, _d, _e;
                    if (response.data && response.data.statusCode === 200) {
                        let locationData = response.data.data.map((location) => {
                            return { label: location.LocationName, value: location.LocationAspireOId };
                        });
                        basicInfo.isCellPhoneChecked = isCellPhoneChecked;
                        handleNext(1, basicInfo, locationData);
                    }
                    else {
                        if ((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.Email) {
                            setBasicInfoErrors((prevState) => { var _a, _b; return (Object.assign(Object.assign({}, prevState), { email: (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.Email })); });
                            (_c = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _c === void 0 ? void 0 : _c.focus();
                        }
                        else if ((_e = (_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.ActivationCode) {
                            setBasicInfoErrors((prevState) => { var _a, _b; return (Object.assign(Object.assign({}, prevState), { dealership_code: (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.ActivationCode })); });
                        }
                        else {
                            setApiError(() => { var _a; return ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message); });
                        }
                    }
                }).catch((error) => {
                    setApiError(() => (error.message));
                });
            }
        }
    };
    const getPasswordHelperText = () => {
        if (basicInfoErrors.password) {
            return basicInfoErrors.password;
        }
        else {
            return React.createElement(PasswordStrength, { password: basicInfo.password, initial_pwdErrors: initial_pwdErrors });
        }
    };
    const isValidFormData = (fieldName = 'All', value) => {
        let _basicInfo = Object.assign(Object.assign({}, basicInfo), { [fieldName]: value });
        let errorInfo = Object.assign({}, basicInfoErrors);
        switch (fieldName) {
            case 'All':
            case 'email':
                errorInfo.email = trimAndValidate(_basicInfo.email, constants.regex.emailRegExp, 'Please enter valid email address');
                if (fieldName !== 'All')
                    break;
            case 'All':
            case 'first_name':
                errorInfo.first_name = isCustomerTypePortal() ? '' : trimAndValidate(_basicInfo.first_name, constants.regex.userNameRegExp, 'Please enter a valid name');
                if (fieldName !== 'All')
                    break;
            case 'All':
            case 'last_name':
                errorInfo.last_name = isCustomerTypePortal() ? '' : trimAndValidate(_basicInfo.last_name, constants.regex.userNameRegExp, 'Please enter a valid name');
                if (fieldName !== 'All')
                    break;
            case 'All':
            case 'phone_number':
                errorInfo.phone_number = trimAndValidate(_basicInfo.phone_number, constants.regex.mobileNoRegExp, 'Please provide a valid phone number');
                if (fieldName !== 'All')
                    break;
            case 'All':
            case 'password':
                if (_basicInfo.password) {
                    errorInfo.password = pwdValidation(_basicInfo.password, initial_pwdErrors) ? '' : messages['Password does not meet the requirements'];
                }
                else {
                    errorInfo.password = messages['This field is required'];
                }
                if (fieldName !== 'All')
                    break;
            case 'All':
            case 'confirm_password':
                if (_basicInfo.confirm_password) {
                    errorInfo.confirm_password = _basicInfo.password === _basicInfo.confirm_password ? '' : messages['Password mismatch. Please use the same password'];
                }
                else {
                    errorInfo.confirm_password = messages['This field is required'];
                }
                if (fieldName !== 'All')
                    break;
            case 'All':
            case 'dealership_code':
                errorInfo.dealership_code = (isCustomerTypePortal() && !(vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.IsActivationCodeEnabled)) ? '' : trimAndValidate(_basicInfo.dealership_code);
                if (fieldName !== 'All')
                    break;
        }
        setBasicInfoErrors((prevState) => (Object.assign({}, errorInfo)));
        return Object.values(errorInfo).every(errorMsg => errorMsg === '');
    };
    const handleOnInputBlur = (e) => {
        const { name, value } = e.target;
        isValidFormData(name, value);
    };
    const isCustomerTypePortal = () => {
        return (vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.PortalType) === 'CUSTOMER';
    };
    return (React.createElement(Box, { sx: { width: '100%', overflow: 'visible' }, mt: '4px', className: "signup_feilds" },
        React.createElement(Grid, { container: true, alignContent: 'flex-start', sx: {
                width: '100%', height: '100%',
                paddingRight: '0px',
                boxSizing: 'content-box'
            } },
            !isCustomerTypePortal() &&
                React.createElement(Grid, { container: true, columnSpacing: 1 },
                    React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 6, pb: '16px' },
                        React.createElement(TextField, { name: 'first_name', label: 'First Name', placeholder: 'First Name *', uiVariant: 'revamp', hideLabel: true, value: basicInfo.first_name, error: Boolean(basicInfoErrors.first_name), error_message: basicInfoErrors.first_name, onChange: handleOnValChange, onBlur: handleOnInputBlur, fullWidth: true, maxLength: 30, isMandatoryField: true })),
                    React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 6, pb: '16px' },
                        React.createElement(TextField, { name: 'last_name', label: 'Last Name', placeholder: 'Last Name *', uiVariant: 'revamp', hideLabel: true, value: basicInfo.last_name, error: Boolean(basicInfoErrors.last_name), error_message: basicInfoErrors.last_name, onChange: handleOnValChange, onBlur: handleOnInputBlur, fullWidth: true, maxLength: 30, isMandatoryField: true }))),
            React.createElement(Grid, { item: true, xs: 12, sm: 12, md: 12, pb: '16px' },
                React.createElement(TextField, { name: 'email', label: 'Email', placeholder: 'Email *', uiVariant: 'revamp', hideLabel: true, value: basicInfo.email, error: Boolean(basicInfoErrors.email), error_message: basicInfoErrors.email, onChange: handleOnValChange, onBlur: handleOnInputBlur, fullWidth: true, maxLength: 60, ref: inputRef, isMandatoryField: true })),
            React.createElement(Grid, { container: true, columnSpacing: 1 },
                React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 6, pb: '16px' },
                    React.createElement(TextField, { name: 'password', label: 'Password', placeholder: 'Password *', uiVariant: 'revamp', hideLabel: true, value: basicInfo.password, error: Boolean(basicInfoErrors.password), error_message: getPasswordHelperText(), inputType: 'password', onChange: handleOnValChange, onBlur: handleOnInputBlur, fullWidth: true, isMandatoryField: true, sx: {
                            '& .MuiFormHelperText-root': {
                                margin: 0
                            }
                        } })),
                React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 6, pb: '16px' },
                    React.createElement(TextField, { name: 'confirm_password', label: 'Confirm Password', placeholder: 'Confirm Password *', uiVariant: 'revamp', hideLabel: true, value: basicInfo.confirm_password, error: Boolean(basicInfoErrors.confirm_password), error_message: basicInfoErrors.confirm_password, inputType: 'password', onChange: handleOnValChange, onPaste: handleOnPasswordPaste, onBlur: handleOnInputBlur, fullWidth: true, isMandatoryField: true }))),
            React.createElement(Grid, { item: true, xs: 12, sm: 12, md: 12, pb: '12px', className: 'signup-password-hint-row' },
                React.createElement(Typography, { variant: 'body2', className: 'passowrd-text' }, "Must be at least 10 characters with an uppercase letter, a lowercase letter, a number, and a special character, excludes # and @")),
            React.createElement(Grid, { item: true, xs: 12, sm: 12, md: 12, pb: '16px' },
                React.createElement(TextField, { name: 'phone_number', label: 'Phone Number', placeholder: 'Phone Number *', uiVariant: 'revamp', hideLabel: true, value: basicInfo.phone_number, error: Boolean(basicInfoErrors.phone_number), error_message: basicInfoErrors.phone_number, onChange: handleOnValChange, onBlur: handleOnInputBlur, fullWidth: true, maxLength: 10, regExp: constants.regex.PhoneNumber_DownPayment, isMandatoryField: true }),
                React.createElement(Stack, { direction: "row", alignItems: "center", spacing: '6px', sx: { '& svg': { fontSize: 22, } } },
                    React.createElement(Checkbox, { checked: isCellPhoneChecked, onChange: handleCheckboxChange, icon: React.createElement(CheckBoxOutlineBlankIcon, null), checkedIcon: React.createElement(CheckBoxOutlinedIcon, null), sx: { p: 0, mr: 1 } }),
                    React.createElement(Typography, { className: 'terms-text' }, "Is the cell number same?"))),
            Boolean(vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.IsActivationCodeEnabled) &&
                React.createElement(Grid, { item: true, xs: 12, sm: 12, md: 12, pb: '16px' },
                    React.createElement(TextField, { name: 'dealership_code', label: 'Activation Code', placeholder: 'Activation Code *', uiVariant: 'revamp', hideLabel: true, value: basicInfo.dealership_code, error: Boolean(basicInfoErrors.dealership_code), error_message: basicInfoErrors.dealership_code, onChange: handleOnValChange, onBlur: handleOnInputBlur, fullWidth: true, className: 'signup-dealer-text', endAdornment: React.createElement(InputAdornment, { position: "end" },
                            React.createElement(Tooltip, { title: 'Contact your Sales Rep for assistance' },
                                React.createElement(IconButton, { edge: "end" },
                                    React.createElement(InfoIcon, null)))), isMandatoryField: true })),
            React.createElement(Typography, { variant: 'body1', className: 'api-eeror' }, apiError),
            React.createElement(Grid, { item: true, xs: 12, sm: 12, md: 12 },
                React.createElement(Box, { className: 'd-flex mt-2' },
                    React.createElement(Button, { onClick: handleOnNextClick, fullWidth: true, variant: 'contained', className: 'btn-txt login-revamp-submit', disabled: !enableNextButton }, "Next"))))));
};
export default BasicInformation;
